import { PreviewVariant } from '../../preview-common/preview-variant.interface';
import { DiscoverAdMobilePreviewComponent } from './discover-ad-mobile/discover-ad-mobile.component';
import {
  VideoPartnersInFeedMobilePreviewComponent
} from './video-partners-in-feed-mobile/video-partners-in-feed-mobile.component';
import {
  VideoPartnersInStreamDesktopPreviewComponent
} from './video-partners-in-stream-desktop/video-partners-in-stream-desktop.component';
import {
  VideoPartnersInStreamMobilePreviewComponent
} from './video-partners-in-stream-mobile/video-partners-in-stream-mobile.component';
import {
  YoutubeHomeFeedAdMobilePreviewComponent
} from './youtube-home-feed-ad-mobile/youtube-home-feed-ad-mobile.component';
import { YoutubeHomeFeedAdTvPreviewComponent } from './youtube-home-feed-ad-tv/youtube-home-feed-ad-tv.component';
import {
  YoutubeShortsAdDesktopFullscreenPreviewComponent
} from './youtube-shorts-ad-desktop/youtube-shorts-ad-desktop-fullscreen.component';
import {
  YoutubeShortsAdDesktopSquarePreviewComponent
} from './youtube-shorts-ad-desktop/youtube-shorts-ad-desktop-square.component';
import {
  YoutubeShortsAdMobileFullscreenPreviewComponent
} from './youtube-shorts-ad-mobile/youtube-shorts-ad-mobile-fullscreen.component';
import {
  YoutubeShortsAdMobileSquarePreviewComponent
} from './youtube-shorts-ad-mobile/youtube-shorts-ad-mobile-square.component';
import {
  YoutubeShortsAdTvFullscreenPreviewComponent
} from './youtube-shorts-ad-tv/youtube-shorts-ad-tv-fullscreen.component';
import { YoutubeShortsAdTvSquarePreviewComponent } from './youtube-shorts-ad-tv/youtube-shorts-ad-tv-square.component';
import { YoutubeWatchAdDesktopPreviewComponent } from './youtube-watch-ad-desktop/youtube-watch-ad-desktop.component';
import { YoutubeWatchAdMobilePreviewComponent } from './youtube-watch-ad-mobile/youtube-watch-ad-mobile.component';
import { YoutubeWatchAdTvPreviewComponent } from './youtube-watch-ad-tv/youtube-watch-ad-tv.component';

export const GEN_VIDEO_VARIANTS: PreviewVariant[] = [
  {
    id: 'discover-mobile-01',
    platform: 'discover',
    device: 'mobile',
    label: 'Discover ad (16:9)',
    component: DiscoverAdMobilePreviewComponent,
  },
  {
    id: 'display-desktop-01',
    platform: 'display',
    device: 'desktop',
    label: 'Google video partners in-stream (16:9)',
    component: VideoPartnersInStreamDesktopPreviewComponent,
  },
  {
    id: 'display-mobile-01',
    platform: 'display',
    device: 'mobile',
    label: 'Google video partners in-stream (16:9)',
    component: VideoPartnersInStreamMobilePreviewComponent,
  },
  {
    id: 'display-mobile-02',
    platform: 'display',
    device: 'mobile',
    label: 'Google video partners in-feed (16:9)',
    component: VideoPartnersInFeedMobilePreviewComponent,
  },
  {
    id: 'youtube-desktop-01',
    platform: 'youtube',
    device: 'desktop',
    label: 'YouTube Shorts ad (9:16)',
    component: YoutubeShortsAdDesktopFullscreenPreviewComponent,
  },
  {
    id: 'youtube-desktop-02',
    platform: 'youtube',
    device: 'desktop',
    label: 'YouTube Shorts ad (1:1)',
    component: YoutubeShortsAdDesktopSquarePreviewComponent,
  },
  {
    id: 'youtube-desktop-03',
    platform: 'youtube',
    device: 'desktop',
    label: 'YouTube watch ad (16:9)',
    component: YoutubeWatchAdDesktopPreviewComponent,
  },
  // ENABLE IF YOU WANT TO DEBUG
  // {
  //   id: 'youtube-desktop-04',
  //   platform: 'youtube',
  //   device: 'desktop',
  //   label: 'Variables (debug)',
  //   component: GenVideoVariablesTablePreviewComponent,
  // },
  {
    id: 'youtube-mobile-01',
    platform: 'youtube',
    device: 'mobile',
    label: 'YouTube Shorts ad (9:16)',
    component: YoutubeShortsAdMobileFullscreenPreviewComponent,
  },
  {
    id: 'youtube-mobile-02',
    platform: 'youtube',
    device: 'mobile',
    label: 'YouTube Shorts ad (1:1)',
    component: YoutubeShortsAdMobileSquarePreviewComponent,
  },
  {
    id: 'youtube-mobile-03',
    platform: 'youtube',
    device: 'mobile',
    label: 'YouTube watch ad (16:9)',
    component: YoutubeWatchAdMobilePreviewComponent,
  },
  {
    id: 'youtube-mobile-04',
    platform: 'youtube',
    device: 'mobile',
    label: 'YouTube home feed ad (16:9)',
    component: YoutubeHomeFeedAdMobilePreviewComponent,
  },
  {
    id: 'youtube-tv-01',
    platform: 'youtube',
    device: 'tv',
    label: 'YouTube Shorts ad (9:16)',
    component: YoutubeShortsAdTvFullscreenPreviewComponent,
  },
  {
    id: 'youtube-tv-02',
    platform: 'youtube',
    device: 'tv',
    label: 'YouTube Shorts ad (1:1)',
    component: YoutubeShortsAdTvSquarePreviewComponent,
  },
  {
    id: 'youtube-tv-03',
    platform: 'youtube',
    device: 'tv',
    label: 'YouTube home feed ad (16:9)',
    component: YoutubeHomeFeedAdTvPreviewComponent,
  },
  {
    id: 'youtube-tv-04',
    platform: 'youtube',
    device: 'tv',
    label: 'YouTube watch ad (16:9)',
    component: YoutubeWatchAdTvPreviewComponent,
  },
];
